<template>
  <el-dialog
    v-bind="$attrs"
    v-on="$listeners"
    :title="$t('doc-list.文档')"
    width="760px"
    class="dialog-dark"
    @open="onOpen"
    @close="onClose"
  >
    <div class="doclist-body">
      <el-row :gutter="20" class="doclist-list">
        <el-col
          v-for="(item, index) in fileList"
          :key="`${item.date + item.filename + item.fileId + index}`"
          :span="6"
        >
          <div
            :class="{
              active: current == item,
              'is-publish': item.publish === 1,
              'is-publish-us': item.publish === 1 && language == 'en-US',
              'is-publish-tw': item.publish === 1 && language == 'zh-TW'
            }"
            class="doclist-item"
            @click="docSelect(item)"
          >
            <div class="doclist-item__img">
              <img :src="getSrc(item)" />
            </div>
            <div class="doclist-item__footer">
              <div class="flex-1 line-clamp2 title">
                <TextTip :text="item.filename" :suffix="true" />
              </div>
              <div class="doclist-item__footer--right">
                <div class="doclist-item__tip">
                  <div v-if="item.style === 'prepare'" class="maincolor">
                    {{ $t('doc-list.上传中') }}
                  </div>
                  <div v-if="item.style === 'uploading'" class="maincolor">
                    {{ item.percent }}
                  </div>
                  <div v-if="item.style === 'fail'" style="color: #ea494b">
                    {{ $t('doc-list.上传失败') }}
                  </div>
                  <div v-if="item.style === 'transcoding'" class="maincolor">
                    {{ item.percent }}
                  </div>
                  <div v-if="item.style === 'transcodingFail'" style="color: #ea494b">
                    {{ $t('doc-list.转码失败') }}
                  </div>
                </div>
                <el-dropdown trigger="click" @command="docAction">
                  <i class="doclist-del el-icon-more" @click.stop></i>
                  <el-dropdown-menu slot="dropdown" class="dropdown-dark">
                    <template v-if="item.style === 'complete'">
                      <el-dropdown-item
                        v-if="item.bindType === 1"
                        :command="{ action: 'link', item }"
                        >{{ $t('doc-list.关联') }}</el-dropdown-item
                      >
                      <el-dropdown-item
                        v-if="item.bindType === 2"
                        :command="{ action: 'unlink', item }"
                        >{{ $t('doc-list.取消关联') }}</el-dropdown-item
                      >
                    </template>
                    <el-dropdown-item
                      :disabled="
                        !(
                          item.publish !== 1 &&
                          item.style !== 'prepare' &&
                          item.style !== 'uploading' &&
                          item.style !== 'transcoding'
                        )
                      "
                    >
                      <el-popconfirm
                        :title="$t('doc-list.你确定要删除这个文档吗')"
                        popper-class="tip-popconfirm"
                        icon="el-icon-info"
                        placement="top"
                        icon-color="#EA494B"
                        @confirm="docDel(item, index)"
                      >
                        <div slot="reference" @click.stop>{{ $t('doc-list.删除') }}</div>
                      </el-popconfirm>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <Progress
              v-if="item.style === 'uploading' || item.style === 'transcoding'"
              :percent="item.percent"
              class="doclist-progress"
            />
          </div>
        </el-col>
        <el-col v-show="limit < 20" :span="6">
          <Upload ref="upload" :mode="0" :fileSize="500" @change="onChange" @on-error="onError">
            <div class="doclist-upload-btn">
              <i class="el-icon-upload2"></i>
              <div>
                {{ $t('doc-list.上传文档') }}
                <el-tooltip class="item" effect="dark" placement="top">
                  <div slot="content">
                    {{ $t('doc-list.格式') }}：ppt、pptx、dps、doc、docx、wps、pdf、png、
                    <br />
                    jpg、jpeg、bmp、txt {{ $t('doc-list.大小') }}：≤500M，{{
                      $t('doc-list.数量')
                    }}：≤20{{ $t('doc-list.个') }}；
                    <br />
                    {{ $t('doc-list.未关联直播间的文档直播结束后将不再保留') }}
                  </div>
                  <img class="tip-icon" :src="require('@/svg/tip.svg')" />
                </el-tooltip>
              </div>
            </div>
          </Upload>
        </el-col>
      </el-row>
    </div>
    <div slot="footer" class="doclist-footer">
      <div class="flex-1">
        <span class="allow">{{ $t('doc-list.发布自动关联直播间') }}</span
        >&nbsp;&nbsp;<el-switch
          v-model="isBindDoc"
          @change="changeBindDoc"
          class="blueSwitch form-dark"
        >
        </el-switch>
      </div>
      <div>
        <el-button class="button-mini" size="mini" @click="cancel">{{
          $t('doc-list.取消')
        }}</el-button>
        <!-- <el-tooltip effect="dark" :content="$t('doc-list.需要获取演示权')" placement="top" :disabled="!!share">
          <el-button :loading="pubLoading" :class="{ 'button-mini': true, 'not-share-auth': !current || !share }"
            type="primary" size="mini" @click="publish">
            {{ $t('doc-list.发布文档') }}
          </el-button>
        </el-tooltip> -->
        <el-button
          :loading="pubLoading"
          :class="{ 'button-mini': true }"
          type="primary"
          size="mini"
          @click="publish"
        >
          {{ $t('doc-list.发布文档') }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {
  Col,
  // Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Link,
  // Popconfirm,
  Row
} from 'element-ui';
import Upload from '@/components/upload';
import Progress from './progress';
import { resourceBind, resourceUnBind, setAutoBind } from '@/api/liveRequest/resource';
import picSrc from '@/assets/images/upload/pic.png';
import pdfSrc from '@/assets/images/upload/pdf.png';
import pptSrc from '@/assets/images/upload/ppt.png';
import wordSrc from '@/assets/images/upload/word.png';
import txtSrc from '@/assets/images/upload/txt.png';
import { pushRoomMessageFunc, removeMessageFunc } from '@/utils/socketMessageDispose';
import Role from '@/mixins/role';
import TextTip from '@/components/textTip';
import { mapGetters } from 'vuex';
export default {
  name: 'DocList',
  components: {
    // [Dialog.name]: Dialog,
    [Row.name]: Row,
    [Col.name]: Col,
    [Link.name]: Link,
    // [Popconfirm.name]: Popconfirm,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    Upload,
    Progress,
    TextTip
  },
  mixins: [Role],
  data() {
    return {
      // 文档列表
      fileList: [],
      // 当前选中文档
      current: undefined,
      // 文档发布loading
      pubLoading: false,
      isBindEvent: false,
      isBindDoc: true //是的自动关联文档
    };
  },
  watch: {
    'liveConfig.autoRef': {
      immediate: true,
      handler(n) {
        this.isBindDoc = n == '1' ? false : true;
      }
    }
  },
  computed: {
    limit() {
      return this.fileList.filter((v) => v.style !== 'fail' && v.bindType !== -1)?.length || 0;
    },
    ...mapGetters(['language', 'liveId', 'liveConfig'])
  },
  created() {
    if (!this.isBindEvent) {
      this.isBindEvent = true;
      pushRoomMessageFunc(this.message_event);
    }
  },
  beforeDestroy() {
    removeMessageFunc(this.message_event);
  },
  methods: {
    message_event({ cmd, requestData }) {
      switch (cmd) {
        case 7107:
          this.message_7107(requestData);
          break;
        case 7127:
          this.message_7127(requestData);
          break;
      }
    },
    message_7107(body) {
      switch (body.cmd) {
        case 3079:
          this.$refs.upload?.transcodingFile(body);
          break;
      }
    },
    message_7127(body) {
      switch (body.event) {
        case 'doc_publish':
        case 'doc_cancel_publish':
          this.updateList();
          break;
      }
      switch (body.cmd) {
        case 3079:
          this.$refs.upload?.transcodingFile(body);
          break;
      }
    },
    onOpen() {
      this.logger.info({
        code: 2008,
        message: {
          current: this.current,
          share: this.share
        }
      });
      this.$nextTick(() => {
        this.updateList();
      });
    },
    onClose() {
      this.current = null;
      this.logger.info({
        code: 2009,
        message: {
          current: this.current,
          share: this.share
        }
      });
    },
    // 文档列表更新
    onChange(files) {
      console.log(files,  'files');
      try {
        this.fileList = files;
      } catch (error) {
        this.fileList = files;
      }
      this.fileList = this.fileList.filter((v) => v.fileSuffix !== 'zip');
    },
    // 上传错误提示
    onError({ type, msg }) {
      switch (type) {
        case 'fileSize':
          this.$message.error(this.$t('doc-list.文档大小不能超过'));
          break;
        case 'fileType':
          this.$message.error(this.$t('doc-list.文档格式错误，请重新选取'));
          break;
        case 'fileDel':
          this.$message.error(msg);
          break;
        case 'fileBind':
          this.$message.error(msg);
          break;
        case 'leftSize':
          this.$alert(this.$t('doc-list.您的帐号存储空间已经不足'), {
            title: this.$t('doc-list.提示'),
            customClass: 'tip-alert text-left',
            confirmButtonText: this.$t('doc-list.我知道了')
          });
          break;
      }
    },
    updateList() {
      this.$refs.upload?.updateFiles();
    },
    // 获取文档图标
    getSrc(item) {
      switch (item?.fileSuffix?.toLowerCase()) {
        case 'png':
        case 'bmp':
        case 'jpg':
        case 'jpeg':
          return picSrc;
        case 'doc':
        case 'docx':
        case 'wps':
          return wordSrc;
        case 'ppt':
        case 'pptx':
        case 'dps':
          return pptSrc;
        case 'pdf':
          return pdfSrc;
        case 'txt':
          return txtSrc;
      }
    },
    // 删除文档
    docDel(item, index) {
      if (item === this.current) {
        this.current = null;
      }
      this.$refs.upload?.delFile(item, index);
    },
    // 选择发布项
    docSelect(item) {
      if (item?.publish === 1) return;
      if (item.style !== 'complete') return;
      if (this.current === item) {
        this.current = null;
      } else {
        this.current = item;
      }
    },
    docAction({ action, item }) {
      switch (action) {
        case 'link':
          this.docLink(item);
          break;
        case 'unlink':
          this.docUnLink(item);
          break;
      }
    },
    // 关联
    async docLink(item) {
      console.log(item);
      const { code } = await resourceBind({
        bindType: 2,
        resourceType: 0,
        resourceId: [item.srcFileId]
      });
      if (code === 200) {
        item.bindType = 2;
      }
    },
    // 关联
    async docUnLink(item) {
      const { code, msg } = await resourceUnBind(item.srcFileId);
      if (code === 200) {
        this.onOpen();
      } else {
        this.$message.error(msg);
      }
    },
    // 发布文档
    async publish() {
      this.logger.info({
        code: 2010,
        message: {
          current: this.current,
          share: this.share
        }
      });
      //TODO 发布的时候根据后台设置判断是否需要演示权，注释不分要放开
      // if (!this.current || !this.share) return
      if (!this.current) return;
      if (this.current?.publish === 1) return;
      this.$emit('publish', this.current, () => {
        this.pubLoading = true;
        return () => {
          this.pubLoading = false;
        };
      });
    },
    // 关闭弹窗
    cancel() {
      this.$emit('update:visible', false);
    },
    // 改变自动关联文档
    changeBindDoc() {
      setAutoBind(this.liveId, this.isBindDoc ? 0 : 1);
    }
  }
};
</script>
<style lang="scss" scoped>
.doclist-body {
  padding: 0 10px;
}

.doclist-list {
  display: flex;
  flex-wrap: wrap;
}

.doclist-item {
  position: relative;
  width: 160px;
  height: 100px;
  margin-bottom: 20px;
  padding: 0 10px;
  font-size: 12px;
  color: #d7dfef;
  background: #2d3052;
  border-radius: 2px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.2);
  cursor: pointer;

  &.active {
    background-color: rgba(57, 134, 238, 0.3);
  }

  &__img {
    padding-top: 15px;
    margin-bottom: 10px;
    text-align: center;

    img {
      width: 28px;
      height: 34px;
      vertical-align: middle;
    }
  }

  &__footer {
    display: flex;
    align-items: flex-end;
    height: 32px;

    &--right {
      display: flex;
      align-items: center;
      margin-left: 10px;
      line-height: 1;
    }
  }

  &__tip {
    transform: scale(0.83333);
    line-height: 1;
  }

  .el-icon-delete {
    cursor: pointer;
  }
}

.doclist-upload-btn {
  @extend .doclist-item;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  color: #acb2bf;

  i {
    margin-top: 10px;
    font-size: 20px;
  }
}

.doclist-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #8a8f99;
  text-align: left;

  &__left {
    padding-right: 95px;
  }
}

.doclist-progress {
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  height: 4px;
}

.doclist-link {
  position: absolute;
  top: 5px;
  right: 8px;
  font-size: 12px;
}

.is-publish {
  cursor: not-allowed;
  background-image: url(~@/assets/images/doc/isPub.png);
  background-size: 46px 46px;
  background-repeat: no-repeat;
}

.is-publish-us {
  background-image: url(~@/assets/images/doc/isPub-US.png);
}

.is-publish-tw {
  background-image: url(~@/assets/images/doc/isPub-TW.png);
}

.is-publish .title {
  color: #727480;
}

.dialog-dark ::v-deep .el-dialog__body {
  min-height: 306px;
  overflow-y: auto;
  max-height: 330px;
}

.doclist-del {
  width: 14px;
  height: 14px;
  cursor: pointer;
  transform: rotate(90deg);
  color: #8a8f99;
  font-size: 14px;
}

.doclist-del-dis {
  color: #727480;
}
</style>
